<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-button (click)="addSchedule()" class="menuitem-ion-button"
        >Add Schedule</ion-button
      >

      <ion-grid>
        <ion-row>
          <ion-col size="1">
            <ion-item> </ion-item>
          </ion-col>
          <ion-col size="3">
            <ion-item>
              <ion-label>Start</ion-label>
            </ion-item>
          </ion-col>
          <ion-col size="3">
            <ion-item>
              <ion-label>End</ion-label>
            </ion-item>
          </ion-col>
          <ion-col size="5">
            <ion-item>
              <ion-label>People</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
        <div *ngFor="let schedule of schedulesList;let i = index">
          <ion-row>
            <ion-col size="1">
              <ion-item>
                <ion-icon
                  name="ios-remove-circle-outline"
                  (click)="removeSchedule(schedule)"
                >
                </ion-icon>
              </ion-item>
            </ion-col>

            <ion-col size="3">
              <ion-item
                (click)="openDatepickerModal($event,schedule.start,'start',i)"
              >
                <ion-button *ngIf="schedule?.start == null">Set...</ion-button>
                <ion-datetime
                  class="pointer"
                  [readonly]="true"
                  displayFormat="DD/MM/YYYY"
                  max="2099-10-31"
                  value="{{schedule?.start}}"
                  [(ngModel)]="schedule.start"
                >
                </ion-datetime>
              </ion-item>
            </ion-col>
            <ion-col size="3">
              <ion-item
                (click)="openDatepickerModal($event,schedule.end,'end',i)"
              >
                <ion-button *ngIf="schedule?.end == null">Set...</ion-button>
                <ion-datetime
                  class="pointer"
                  [readonly]="true"
                  displayFormat="DD/MM/YYYY"
                  max="2099-10-31"
                  value="{{schedule?.end}}"
                  [(ngModel)]="schedule.end"
                >
                </ion-datetime>
              </ion-item>
            </ion-col>
            <ion-col size="5">
              <ion-label
                >People selected : {{schedule.people.length}}</ion-label
              >
              <ion-button (click)="addPeople(i)">Add users...</ion-button>
            </ion-col>
          </ion-row>
        </div>
      </ion-grid>

      <br />
      <br />
      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Close</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
